<div class="nid-choice-backdrop" (click)="back()"></div>
<div class="nid-choice" [dir]="data.dir" role="dialog" aria-modal="true">
    <div class="nid-choice__header">
        <h5 class="nid-choice__title">{{'add-staff.nid-choice.title' | translate}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="back()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="nid-choice__body">
        <!-- phone and National ID carry data-pii="redact": Live Help masks only those elements in its screen share -->
        <p class="nid-choice__text">{{'add-staff.nid-choice.text-before' | translate}}
            <span dir="ltr" data-pii="redact">{{data.phone}}</span>
            {{'add-staff.nid-choice.text-after' | translate}}</p>

        <label class="nid-choice__option" [class.nid-choice__option--selected]="choice === 'existing'">
            <input type="radio" name="nationalIdChoice" value="existing" [(ngModel)]="choice">
            <span class="nid-choice__option-text">
                <span class="nid-choice__title-text">{{'add-staff.nid-choice.existing-title' | translate}}</span>
                <span class="nid-choice__label"><span dir="ltr">&bull;&bull;&bull;&bull; {{data.existingLast4}}</span>
                    · {{'add-staff.nid-choice.existing-sub' | translate}}</span>
            </span>
        </label>

        <label class="nid-choice__option" [class.nid-choice__option--selected]="choice === 'new'">
            <input type="radio" name="nationalIdChoice" value="new" [(ngModel)]="choice">
            <span class="nid-choice__option-text">
                <span class="nid-choice__title-text">{{'add-staff.nid-choice.new-title' | translate}}</span>
                <span class="nid-choice__label"><span dir="ltr" data-pii="redact">{{data.newNationalId}}</span>
                    · {{'add-staff.nid-choice.new-sub' | translate}}</span>
                <span class="nid-choice__hint">{{'add-staff.nid-choice.new-hint' | translate}}</span>
            </span>
        </label>
    </div>
    <div class="nid-choice__footer">
        <button type="button" class="btn btn-outline-primary" (click)="back()">{{'add-staff.nid-choice.back' |
            translate}}</button>
        <button type="button" class="btn btn-primary" [disabled]="!choice" (click)="useThis()">{{'add-staff.nid-choice.use-this'
            | translate}}</button>
    </div>
</div>
